// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f89f98bb","453":"2968244d","455":"ba383ad5","977":"de9a2830"}[chunkId] + ".chunk.js";
};